import { CaseIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";
import PlayerMenuCharacterFadeBox from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterFadeBox";

export default function PlayerMenuCharacterJobCardContainer() {
  return (
    <PlayerMenuCharacterDataCard>
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col items-center">
          <div className="w-full relative flex items-center gap-3.5 overflow-clip">
            <PlayerMenuCharacterFadeBox icon={CaseIcon} />
            <div>
              <div className="text-13 font-bold uppercase">НЕТ РАБОТЫ</div>
              <div className="text-10 font-bold text-white/50 uppercase mt-1">ВЫ НЕ РАБОТАЕТЕ</div>
            </div>
          </div>
        </div>
        <SoundButton className="w-fit h-[2.625rem] gap-2.5 mt-2.5" variant="soft" color="gray">
          <CaseIcon size={16} />
          НАЙТИ РАБОТУ
        </SoundButton>
        <div className="mt-auto text-18 font-bold">Работа</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
